module.exports = __webpack_public_path__ + "static/media/238exceptself.36d5c8ac.png";